import React, { useEffect, useState } from 'react';
import {
  Block,
  Flex,
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
} from '../../../components/common/StyledComponent/CommonStyledComponent';
import {
  HighlightBlock,
  ModalCard,
  ModalCloseButton,
  ModalOverlay,
  PillChip,
  PillWrapper,
  ResponseContent,
  SourcesAccordionButton,
  SourcesChevron,
  SourcesPanel,
  SuggestedButton,
} from '../AskAIPageStyles';
import AIRecommendationCarouselSection from './AIRecommendationCarouselSection';
import AskAIAccordionSourceCard from './AskAIAccordionSourceCard';
import AskAIResponseFeedback from './AskAIResponseFeedback';
import CourseDropdown from './CourseDropdown';
import { useSelector } from 'react-redux';
import { findCourseById, getSuggestionData } from '../../../utility/utils';
import { TextLink } from '@vds/buttons';

// Module-level coordination so multiple AskAISuggestionResponse accordions
// mounted in the same chat thread cooperate: whenever a new one opens its
// Sources accordion (either automatically when its citations first appear
// or manually via the toggle), any previously open accordion closes.
let __askAISourcesActiveInstanceId = 0;
let __askAISourcesNextInstanceId = 0;
const __askAISourcesListeners = new Set();
const __broadcastAskAISourcesActive = (instanceId) => {
  __askAISourcesActiveInstanceId = instanceId;
  __askAISourcesListeners.forEach((listener) => {
    try { listener(instanceId); } catch (err) { /* noop */ }
  });
};

const AskAISuggestionResponse = ({
  chatHistory,
  citations: citationsProp,
  selectedSuggestion,
  isSourcesOpen,
  isSourcesClosing,
  handleSourcesToggle,
  handleSourcesPanelAnimationEnd,
  selectedThumb,
  handleThumbClick,
  showFeedbackPanel,
  isFeedbackClosing,
  closeFeedbackPanel,
  handleFeedbackAnimationEnd,
  handleTopRecoClick,
  isSearchDisabled,
}) => {
  const citations = chatHistory?.isOverride
    ? []
    : citationsProp !== undefined
      ? (citationsProp || [])
      : (chatHistory?.[chatHistory?.length - 1]?.citations || []);
  const newSuggestionsData = getSuggestionData();
  const ai_searchJsonData = JSON.parse(localStorage.getItem('aisearch_landingpage_data')) || {};
  const ai_suggestionData = newSuggestionsData || JSON.parse(localStorage.getItem('aisearch_suggestions_data'))?.data || {};
  const resourceCardParams = document.querySelector('.aiattr')?.getAttribute('data-imgqueryparam');
  const [sourceData, setSourceData] = useState([]);
  const quicktipsData = useSelector((state) => state?.Aem?.quickTipData?.combinedQuickTips);
  console.log('^^quicktipsData', quicktipsData);
  const instanceIdRef = React.useRef(null);
  if (instanceIdRef.current === null) {
    __askAISourcesNextInstanceId += 1;
    instanceIdRef.current = __askAISourcesNextInstanceId;
  }
  const sourcesButtonRef = React.useRef(null);
  const hasFocusedSourcesRef = React.useRef(false);
  const [localSourcesOpen, setLocalSourcesOpen] = useState(false);
  const [localSourcesClosing, setLocalSourcesClosing] = useState(false);
  const hasAutoOpenedRef = React.useRef(false);

  // Auto-open this instance the first time its resolved citations arrive.
  useEffect(() => {
    if (!hasAutoOpenedRef.current && sourceData && sourceData.length > 0) {
      hasAutoOpenedRef.current = true;
      __broadcastAskAISourcesActive(instanceIdRef.current);
      setLocalSourcesClosing(false);
      setLocalSourcesOpen(true);
    }
    if (!hasFocusedSourcesRef.current) {
      hasFocusedSourcesRef.current = true;
      window.requestAnimationFrame(() => {
        sourcesButtonRef.current?.focus();
      });
    }
  }, [sourceData]);

  // Listen for other instances becoming active so we can close ourselves.
  useEffect(() => {
    const listener = (activeInstanceId) => {
      if (activeInstanceId !== instanceIdRef.current) {
        setLocalSourcesOpen((prevOpen) => {
          if (prevOpen) {
            setLocalSourcesClosing(true);
          }
          return false;
        });
      }
    };
    __askAISourcesListeners.add(listener);
    return () => {
      __askAISourcesListeners.delete(listener);
    };
  }, []);

  const handleLocalSourcesToggle = () => {
    if (localSourcesOpen) {
      setLocalSourcesClosing(true);
      setLocalSourcesOpen(false);
    } else {
      __broadcastAskAISourcesActive(instanceIdRef.current);
      setLocalSourcesClosing(false);
      setLocalSourcesOpen(true);
    }
  };

  const handleLocalSourcesPanelAnimationEnd = () => {
    if (localSourcesClosing) {
      setLocalSourcesClosing(false);
    }
  };
  const [showCourseModal, setShowCourseModal] = useState(false);
  const allTopicsData_ai = useSelector((state) => state?.Aem?.topics?.allTopicsData) || {};
  const isCompactViewport = window.innerWidth <= TABLET_BREAKPOINT;
  const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
  const isTablet =
    window.innerWidth > MOBILE_BREAKPOINT &&
    window.innerWidth <= TABLET_BREAKPOINT;
    console.log('^^allTopicsData_ai>:', allTopicsData_ai);
  useEffect(() => {
    const originalHtmlOverflow = document.documentElement.style.overflow;
    const originalBodyOverflow = document.body.style.overflow;

    if (showCourseModal) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.documentElement.style.overflow = originalHtmlOverflow;
      document.body.style.overflow = originalBodyOverflow;
    };
  }, [showCourseModal]);

  useEffect(() => {
    if (!showCourseModal) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setShowCourseModal(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [showCourseModal]);

  const handlePillChipClick = () => {
    if (isCompactViewport) {
      setShowCourseModal(true);
    }
  };

  const renderPillChip = () => (
    <PillChip
      as={isCompactViewport ? 'button' : 'span'}
      type={isCompactViewport ? 'button' : undefined}
      className="vds-micro"
      onClick={isCompactViewport ? handlePillChipClick : undefined}
      aria-haspopup={isCompactViewport ? 'dialog' : undefined}
      aria-expanded={isCompactViewport ? showCourseModal : undefined}
    >
      Intro to Online... +2
    </PillChip>
  );
// logic 
useEffect(() => {
  if (citations && citations.length > 0) {
    let resourcesData = [];
        (citations || [])?.map(function (item) { 
          // If the citation item has no `id` but is a course page,
          // derive the id from the last segment of `recordUrl`
          // e.g. "https://.../course-details/course:15885526" -> "course:15885526"
           if (
              typeof item?.type === 'string' &&
              item.type.toLowerCase() === 'unstructured' &&
              typeof item?.recordUrl === 'string'
          ) {
              const match = item.recordUrl.match(/course_(\d+)/i);
              console.log('^^match', match);
              if (match && match[1]) {
                  item.id = `course:${match[1]}`;
              }
          }
          if (
            !item?.id &&
            typeof item?.type === 'string' &&
            item.type.toLowerCase() === 'page' &&
            typeof item?.category === 'string' &&
            item.category.toLowerCase() === 'course' &&
            typeof item?.recordUrl === 'string' &&
            item.recordUrl.trim() !== '' &&
            (/(?:course-details|learning-details)\//i).test(item.recordUrl)
          ) {
            try {
              const parsedRecordUrl = new URL(item.recordUrl, window.location.origin);
              const pathSegments = parsedRecordUrl.pathname
                .split('/')
                .filter((segment) => segment && segment.trim() !== '');
              const lastSegment = pathSegments[pathSegments.length - 1];
              if (lastSegment) {
                item.id = decodeURIComponent(lastSegment);
                // If the derived id is purely numeric, flag this citation as a Quick Tip
                if (/^\d+$/.test(item.id)) {
                  item.format = 'Quick Tip';
                }
              }
            } catch (e) {
              const match = item.recordUrl.match(/(?:course-details|learning-details)\/([^/?#]+)/i);
              if (match && match[1]) {
                item.id = decodeURIComponent(match[1]);
              }
            }
          }

        let courseData = findCourseById(item?.id, ai_suggestionData, item, ai_searchJsonData);
      //  debugger; 
       if(!courseData) {
            let mappedResource = resourceTypeMapping(item, ai_searchJsonData);
            if (mappedResource) {
              resourcesData.push({ ...mappedResource, __resourceId: item?.id ?? null });
            }
        }

        if (courseData?.resourceType != null && ai_searchJsonData) {
            let pathSp = item?.recordUrl || "";
            const launchUrl = courseData?.resource?.launchUrl;
             const aemImageUrl = courseData?.resource?.imageUrl;
            if (typeof pathSp === "string" && pathSp.trim() !== "") {
              try {
                const parsedUrl = new URL(pathSp, window.location.origin);
                pathSp = parsedUrl?.pathname || pathSp;
              } catch (e) {
                pathSp = launchUrl;
              }
              if(item.type == 'unstructured'){
                 pathSp = '/course-details/' + item?.id;
                 item.recordTitle= courseData?.resource?.title || item.recordTitle;
              }
            }
            const resourceImgUrl = () => {
              if( courseData?.resourceType == 'promotion'){
                return item?.imageUrl;
              }
              const baseUrl = ai_searchJsonData?.imgBaseUrl;
              const numericId = item?.id?.split(":")[1]?.trim();
              if (!numericId) {
                return item?.imageUrl || aemImageUrl || "";
              }
              const constructedUrl = `${baseUrl}${numericId}${resourceCardParams || ""}`;
              try {
                new URL(constructedUrl);
                return constructedUrl;
              } catch (e) {
                return item?.imageUrl || aemImageUrl  || "";
              }
            };

         resourcesData.push({
            eyebrowText: ai_searchJsonData?.['typeaheadCardsMapping']?.[courseData?.resourceType]?.eyebrowText || item.eyebrowText || "",
            imageUrl: courseData?.resourceType == 'promotion' ? (item?.type == 'page' ? courseData?.resource?.imgPath : item?.imageUrl ) : resourceImgUrl(),
            title: courseData?.resourceType == 'promotion' ? (item?.type == 'page' ? courseData?.resource?.title : item?.recordTitle ) : item?.recordTitle  || "",
            redirectUrl: courseData?.resourceType == 'promotion' ? `/course-details/${item?.id}` : pathSp || item?.launchUrl || "",
            lmsImage:item?.imageUrl || aemImageUrl || "",
            eventSerpName: item?.eventSerpName || "",
            __resourceId: item?.id ?? null,
          });
        } else if (courseData?.eyebrowText != null || courseData?.title != null) {
          resourcesData.push({ ...courseData, __resourceId: item?.id ?? null });
        }


      });
    const seenResourceKeys = new Set();
    const seenResourceIds = new Set();
    const uniqueResourcesData = resourcesData.filter((resource) => {
      const resourceId = resource?.__resourceId;
      if (resourceId != null && resourceId !== "") {
        if (seenResourceIds.has(resourceId)) {
          return false;
        }
        seenResourceIds.add(resourceId);
        return true;
      }
      const dedupeKey = JSON.stringify([
        resource?.redirectUrl || "",
        resource?.title || "",
        resource?.eyebrowText || "",
        resource?.eventSerpName || "",
      ]);
      if (seenResourceKeys.has(dedupeKey)) {
        return false;
      }
      seenResourceKeys.add(dedupeKey);
      return true;
    }).map(({ __resourceId, ...resource }) => resource);
    setSourceData(uniqueResourcesData);
   
  }
  
}, [citations,resourceCardParams]);







  const getQuickTipByResourceId = (resourceId, quickTips = []) => {
    if (!resourceId || !Array.isArray(quickTips)) {
      return null;
    }
    quickTips?.map((quickTip) => { console.log('^^quickTips>:', quickTip?.qtid);});
   
    return quickTips.find((quickTip) => String(quickTip?.qtid) === String(resourceId)) || null;
  };

  const resourceTypeMapping = ( resource, aisearchJsonData=[]) => {
    console.log('^^aisearchJsonData>:', aisearchJsonData);
  // Check if resource type is instructor or spotlight
  if (resource?.type && (resource.type === 'instructor' || resource.type === 'spotlight' || resource.type === 'grantstories')) {
    let sectionIdLink =  aisearchJsonData?.['typeaheadCardsMapping']?.[resource?.type]?.link ?? null;
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.[resource.type]?.eyebrowText || "",
      // imageUrl: `${aiSearchDomainUrl}${resource?.imageUrl}` || "",
      imageUrl: `${aisearchJsonData?.['typeaheadCardsMapping']?.[resource.type]?.aiImgUrl}${aisearchJsonData?.imgqueryparam ? aisearchJsonData?.imgqueryparam : '?wid=68&hei=68&fit=crop,1&resMode=sharp2&op_sharpen=1'}` || "",
      title: resource?.recordTitle || "",
      redirectUrl: resource.type === 'instructor' ? `/instructor-details/${resource?.id}` : resource.type === 'grantstories' ? (sectionIdLink ? sectionIdLink : '/funding#storiesSection') : ( sectionIdLink ? sectionIdLink : '/community#spotlightSection') || "",
      eventSerpName: resource?.eventSerpName || "",
    };
  }else if(resource?.id  && resource?.format == 'Quick Tip'){
    let matchedQuickTip = null;
    if(resource?.type === 'page'){
    const storedQuicktips = localStorage.getItem('allQuicktipsData');
    let allQuicktipsData = [];
    if (storedQuicktips) {
      try {
        const parsedQuicktips = JSON.parse(storedQuicktips);
        allQuicktipsData = Array.isArray(parsedQuicktips) ? parsedQuicktips : [];
      } catch (e) {
        allQuicktipsData = [];
      }
    }
    if (!allQuicktipsData.length && Array.isArray(quicktipsData)) {
      allQuicktipsData = quicktipsData;
    }
    matchedQuickTip = getQuickTipByResourceId(resource?.id, allQuicktipsData);
    console.log('^^matchedQuickTip>:', matchedQuickTip);
  }

    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.['quicktips']?.eyebrowText || "",
      imageUrl: `${resource?.type === 'page' ? matchedQuickTip?.qtimage : resource?.imageUrl}${aisearchJsonData?.imgqueryparam ? aisearchJsonData?.imgqueryparam : '?wid=68&hei=68&fit=crop,1&resMode=sharp2&op_sharpen=1'}` || "",
      title: resource?.type === 'page' ? matchedQuickTip?.qtcardtitle : resource?.recordTitle || "",
      redirectUrl: `/course-details/${resource?.id}` || `${resource?.recordUrl}` || "",
      eventSerpName: resource?.eventSerpName || "",
    };
  }else if(!resource?.id && typeof resource?.recordUrl === 'string' && resource.recordUrl.includes('/funding')){
    const fundingEyebrowKey = resource.recordUrl.includes('/funding/details') ? 'funding/details' : 'funding';
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.[fundingEyebrowKey]?.eyebrowText || "",
      imageUrl: `${aisearchJsonData?.['typeaheadCardsMapping']?.[fundingEyebrowKey]?.aiImgUrl}${aisearchJsonData?.imgqueryparam ? aisearchJsonData?.imgqueryparam : '?wid=68&hei=68&fit=crop,1&resMode=sharp2&op_sharpen=1'}` || `${resource?.imageUrl}` || "",
      title: resource?.recordTitle || "",
      redirectUrl: `/${fundingEyebrowKey}`,
      eventSerpName: resource?.eventSerpName || "",
    };
  }else if(!resource?.id && typeof resource?.recordUrl === 'string' && resource.recordUrl.includes('/customerSupport')){
    const customerSupportSuffix = (resource.recordUrl.split('/customerSupport/')[1] || '').split(/[?#]/)[0].replace(/^\/+|\/+$/g, '');
    const customerSupportEyebrowKey = customerSupportSuffix ? `customerSupport/${customerSupportSuffix}` : 'customerSupport';
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.[customerSupportEyebrowKey]?.eyebrowText || "",
      imageUrl: `${aisearchJsonData?.['typeaheadCardsMapping']?.[customerSupportEyebrowKey]?.aiImgUrl}${aisearchJsonData?.imgqueryparam ? aisearchJsonData?.imgqueryparam : '?wid=68&hei=68&fit=crop,1&resMode=sharp2&op_sharpen=1'}` || `${resource?.imageUrl}` || "",
      title: resource?.recordTitle || "",
      redirectUrl: `/${customerSupportEyebrowKey}`,
      eventSerpName: resource?.eventSerpName || "",
    };
  } else if(!resource?.id && typeof resource?.recordUrl === 'string' && resource.recordUrl.includes('/results/')){
    const resultsSuffix = (resource.recordUrl.split('/results/')[1] || '').split(/[?#]/)[0].replace(/^\/+|\/+$/g, '').toLowerCase();
    const resultsEyebrowKey = resultsSuffix ? `results/${resultsSuffix}` : 'results';
    const normalizedResultsSuffix = resultsSuffix.replace(/\s+/g, '');
    const topicsList_ai = Array.isArray(allTopicsData_ai) ? allTopicsData_ai : Object.values(allTopicsData_ai || {});
    const matchedTopic_ai = topicsList_ai.find((topic) => (topic?.value || '').toLowerCase().replace(/\s+/g, '') === normalizedResultsSuffix);
  
     return {
      eyebrowText:  aisearchJsonData?.['typeaheadCardsMapping']?.['results']?.eyebrowText || "",
      imageUrl: `${matchedTopic_ai?.aiImgUrl}${aisearchJsonData?.imgqueryparam ? aisearchJsonData?.imgqueryparam : '?wid=68&hei=68&fit=crop,1&resMode=sharp2&op_sharpen=1'}` || aisearchJsonData?.['typeaheadCardsMapping']?.['results']?.aiImgUrl || `${resource?.imageUrl}` || "",
      title: matchedTopic_ai?.label || resource?.recordTitle  || "",
      redirectUrl: `/${resultsEyebrowKey}`,
      eventSerpName: resource?.eventSerpName || "",
    };
  } else if(!resource?.id && typeof resource?.recordUrl === 'string' && resource.recordUrl.includes('/category/')){
    const categorySuffix = (resource.recordUrl.split('/category/')[1] || '').split(/[/?#]/)[0].trim().toLowerCase();
    const categoryEyebrowKey = categorySuffix ? `category${categorySuffix}` : '';
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.[categoryEyebrowKey]?.eyebrowText || aisearchJsonData?.['typeaheadCardsMapping']?.['categoryevents']?.eyebrowText || "",
      imageUrl: `${aisearchJsonData?.['typeaheadCardsMapping']?.[categoryEyebrowKey]?.aiImgUrl}${aisearchJsonData?.imgqueryparam ? aisearchJsonData?.imgqueryparam : '?wid=68&hei=68&fit=crop,1&resMode=sharp2&op_sharpen=1'}` || `${resource?.imageUrl}` || "",
      title: resource?.recordTitle  || "",
      redirectUrl: `${categorySuffix ? `/category/${categorySuffix}` : ''}`,
      eventSerpName: resource?.eventSerpName || "",
    };
    } else if(!resource?.id && typeof resource?.recordUrl === 'string') {
    
       return {
         eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.['other']?.eyebrowText || "",
         imageUrl: `${aisearchJsonData?.['typeaheadCardsMapping']?.['other']?.aiImgUrl}${aisearchJsonData?.imgqueryparam ? aisearchJsonData?.imgqueryparam : '?wid=68&hei=68&fit=crop,1&resMode=sharp2&op_sharpen=1'}` || `${resource?.imageUrl}` || "",
         title: resource?.recordTitle || aisearchJsonData?.['typeaheadCardsMapping']?.['other']?.label || "",
         redirectUrl: resource?.recordUrl || "",
         eventSerpName: resource?.eventSerpName || "",
       };
    
  } else if (!resource?.id && typeof resource?.recordUrl === 'string') {
    const normalizedLaunchUrl = resource.recordUrl.trim().replace(/\/+$/, '');
    const baseDomain = aisearchJsonData?.config?.domainPath;
    if (normalizedLaunchUrl === baseDomain) {
      return {
        eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.['other']?.eyebrowText || "",
        imageUrl: `${aisearchJsonData?.['typeaheadCardsMapping']?.['other']?.aiImgUrl}${aisearchJsonData?.imgqueryparam ? aisearchJsonData?.imgqueryparam : '?wid=68&hei=68&fit=crop,1&resMode=sharp2&op_sharpen=1'}` || `${resource?.imageUrl}` || "",
        title: resource?.recordTitle || aisearchJsonData?.['typeaheadCardsMapping']?.['other']?.label || "",
        redirectUrl: resource?.recordUrl || "",
        eventSerpName: resource?.eventSerpName || "",
      };
    }
     
   }

  return null;
}
  console.log('^^soucedata>:', sourceData);
  return (
    <>
      <ResponseContent>
        {/* <Block padding={isMobile ? '0 16px' : '0 24px'} className="vds-title-md  mobile-vds-title-sm font-eDS-bold mb-8X">
          I am interested in {selectedSuggestion.toLowerCase()}
        </Block>
        <Block padding={isMobile ? '0 16px' : '0 24px'} className="vds-title-xs mobile-vds-title-2xs mb-6X">
          Growth marketing focuses on driving sustainable business
          growth across the entire customer journey.
        </Block>
        <Block padding={isMobile ? '0 16px' : '0 24px'} className="vds-title-xs mobile-vds-title-2xs">
          <HighlightBlock className="vds-title-xs mobile-vds-title-2xs">
            Sometimes referred to as growth hacking, growth marketing
            drives user acquisition, keeps customers engaged, retains
            them and turns them into brand champions. It&apos;s about
            acquiring customers who are going to stick around and
            focusing on the entire funnel.
            <PillWrapper>
              {renderPillChip()}
              <CourseDropdown />
            </PillWrapper>
          </HighlightBlock>
        </Block>
        <Block padding={isMobile ? '0 16px' : '0 24px'} className="vds-title-xs mobile-vds-title-2xs">
          <HighlightBlock className="vds-title-xs mobile-vds-title-2xs">
            Growth marketing allows you to target exactly the clients
            who are looking for your services and products and find the
            strategies that actually bring in customers and drive sales.
            <PillWrapper>
              {renderPillChip()}
              <CourseDropdown />
            </PillWrapper>
          </HighlightBlock>
        </Block> */}
        { citations && citations?.length >0 && sourceData && sourceData?.length>0  && <Block padding={isMobile ? '0 16px' : '0 24px'}>
          <Flex justifyContent="space-between" alignItems="center">
          <SourcesAccordionButton
            ref={sourcesButtonRef}
            type="button"
            onClick={handleLocalSourcesToggle}
            aria-expanded={localSourcesOpen}
            aria-controls="ask-ai-sources-accordion"
          >
            <span className="vds-body-lg font-eDS-bold">Sources</span>
            <SourcesChevron
              open={localSourcesOpen}
              name='down-caret'
              size={20}
              color='#000000'
            />
          </SourcesAccordionButton>
          {/*showViewAllLink && <a href="/category/mylibrary" size="large">View All</a>*/}
          </Flex>
          {(localSourcesOpen || localSourcesClosing) && (
            <SourcesPanel
              id="ask-ai-sources-accordion"
              className="vds-body-sm"
              $isClosing={localSourcesClosing}
              onAnimationEnd={handleLocalSourcesPanelAnimationEnd}
            >
              {sourceData.map((citation, index) => (
                <AskAIAccordionSourceCard
                  citation={citation}
                  key={index}
                  recordTitle={citation.title}
                  imageUrl={citation.imageUrl}
                   lmsImage={citation?.lmsImage}
                  recordUrl={citation.redirectUrl}
                  category={citation.eyebrowText}
                  id={index}
                />
              ))}
            </SourcesPanel>
          )}
        </Block>}
        {/* <AIRecommendationCarouselSection /> */}
        {/* <Flex padding={isMobile ? '0 16px' : '0 24px'} flexDirection="column" marginTop="32px" gap="32px">
          <div className="vds-title-xs mobile-vds-title-2xs">
            Would you like to focus on strategies for attracting new
            customers or building long-term loyalty?{' '}
          </div>
          <Flex gap="12px" flexWrap="wrap">
            <SuggestedButton onClick={() =>{ !isSearchDisabled && handleTopRecoClick('Attracting new customers')} }>
              <div className="vds-body-lg font-eDS-bold mobile-vds-body-sm mobile-font-eTX-bold">
                Attracting new customers
              </div>
            </SuggestedButton>
            <SuggestedButton onClick={() =>{ !isSearchDisabled &&  handleTopRecoClick('Building long-term loyalty')}}>
              <div className="vds-body-lg font-eDS-bold mobile-vds-body-sm mobile-font-eTX-bold">
                Building long-term loyalty
              </div>
            </SuggestedButton>
          </Flex>
        </Flex> */}
        {/* <Block marginTop="32px" padding={isMobile ? '0 16px' : '0 24px'}>
          <AskAIResponseFeedback
            selectedThumb={selectedThumb}
            onThumbClick={handleThumbClick}
            showFeedbackPanel={showFeedbackPanel}
            isFeedbackClosing={isFeedbackClosing}
            onCloseFeedback={closeFeedbackPanel}
            onFeedbackAnimationEnd={handleFeedbackAnimationEnd}
          />
        </Block> */}
      </ResponseContent>

      {showCourseModal && (
        <ModalOverlay onClick={() => setShowCourseModal(false)}>
          <ModalCard
            role="dialog"
            aria-modal="true"
            aria-label="Sources"
            style={{
              width: isTablet ? '592px' : undefined,
              maxWidth: isTablet ? '592px' : isMobile ? undefined : '311px',
              height: isTablet ? '493px' : undefined,
              padding: isTablet ? '48px' : !isMobile ? '20px 0 0' : undefined,
              minHeight: isMobile ? undefined : 'auto',
            }}
            onClick={(event) => event.stopPropagation()}
          >
            <ModalCloseButton
              type="button"
              onClick={() => setShowCourseModal(false)}
              aria-label="Close"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L15 15M15 1L1 15" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </ModalCloseButton>
            <Block
              className='font-eDS-bold vds-title-lg mobile-vds-title-md'
              paddingBottom={isMobile ? '24px' : '32px'}
            >
              Sources
            </Block>
            <CourseDropdown variant="modal" />
          </ModalCard>
        </ModalOverlay>
      )}
    </>
  );
};

export default AskAISuggestionResponse;
